import React, { useEffect, useRef} from "react";
import { Link, useLocation } from "react-router-dom";
import '../styles/Header.css';
import Gif from '../assets/webm/ssgifwebm.webm';
import GifMp4 from '../assets/webm/ssgifwebm.mp4';
import ScrollDown from '../assets/icons/scroll.svg';

function Header({ onScrollToDishSection }) {

    const location = useLocation();

    const isMenuPage = location.pathname === '/menu';
    const isContactPage = location.pathname === '/kontakt';
    const isAboutPage = location.pathname === '/o-nas';
    const isGalleryPage = location.pathname === '/galeria';
    const isPolicyPage = location.pathname === '/polityka';
    const isHomePage = location.pathname === '/';

        //Jednokrotne odświezanie strony

    useEffect(() => {
        const hasRefreshed = sessionStorage.getItem("hasRefreshedOnce");
    
        if (!hasRefreshed) {
            sessionStorage.setItem("hasRefreshedOnce", "true");
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }, []);

    const getHeaderText = () => {
        switch (location.pathname) {
            case '/o-nas':
                return 'O nas';
            case '/menu':
                return 'Menu';
            case '/galeria':
                return 'Galeria';
            case '/kontakt':
                return 'Kontakt';
            default:
                return 'Tradycyjna polska kuchnia w Andrychowie';
        }}

    const getSubtitleText = () => {
        switch (location.pathname) {
            case '/o-nas':
                return 'Poznaj historię naszej restauracji, gdzie tradycja łączy się z nowoczesnością.'
            case '/menu':
                return 'Poznaj nasze wyśmienite potrawy, przygotowywane z najświeższych składników.'
            case '/galeria':
                return 'Zobacz, jak serwujemy nasze dania w unikalnej atmosferze.'
            case '/kontakt':
                return 'Skontaktuj się z nami, zarezerwuj stolik lub zapytaj o ofertę specjalną.'
            default:
                return 'Tradycyjna polska kuchnia połączona z nowoczesnymi potrawami, smacznie, przyjaźnie, kolorowo. Po prostu u Samych Swoich.'
    }}

    const closeMenu = () => {
        const navbarToggler = document.querySelector(".navbar-toggler");
        const navbarCollapse = document.querySelector("#navbarNav");
        if (navbarToggler && navbarCollapse.classList.contains("show")) {
            navbarToggler.click();
        }
    };

    const handleScrollDown = () => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
    }

    if (isMenuPage || isContactPage || isHomePage || isAboutPage || isGalleryPage || isPolicyPage) {
        
        return (
            <header className={`header-img ${isHomePage ? 'banner-home' : 'banner-other'}`}>
                <video className="header-bg" autoPlay muted loop playsInline preload="auto">
                    <source src={Gif} type="video/webm" />
                    <source src={GifMp4} type="video/mp4" />
                    Twoja przeglądarka nie obsługuje tego wideo.
                </video>
                {/* <img className="header-bg zoom-in-out" src={require('../assets/photos/white_table.webp')} alt="tło" /> */}
                <nav className="navbar navbar-expand-md navbar-light">
                    <div className="container">
                        <Link to={'/'} className="navbar-brand text-white">
                            <img src={require('../assets/icons/logo.png')} alt="logo" className="logo" />
                        </Link>
                        <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        style={{borderColor: "transparent", outline: 'none', boxShadow: 'none'}}>
                            <span className="navbar-toggler-icon" style={{filter: 'invert(1)'}}></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item text-center">
                                    <Link to={'/'} onClick={closeMenu} className="nav-link text-white">STRONA GŁÓWNA</Link>
                                </li>
                                <div className="nav-line d-none d-md-block"></div>
                                <li className="nav-item text-center">
                                    <Link to={'/menu'} onClick={closeMenu} className="nav-link text-white">MENU</Link>
                                </li>
                                <div className="nav-line d-none d-md-block"></div>
                                <li className="nav-item text-center">
                                    <Link to={'/galeria'} onClick={closeMenu} className="nav-link text-white">GALERIA</Link>
                                </li>
                                <div className="nav-line d-none d-md-block"></div>
                                <li className="nav-item text-center">
                                    <Link to={"/o-nas"} onClick={closeMenu} className="nav-link text-white">O NAS</Link>
                                </li>
                                <div className="nav-line d-none d-md-block"></div>
                                <li className="nav-item text-center">
                                    <Link to={"/kontakt"} onClick={closeMenu} className="nav-link text-white">KONTAKT</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div className={`container container-custom d-flex align-items-center ${isHomePage ? "py-custom-expanded" : "py-custom"}`}>
                    <div className={`banner-text-container text-white ${isHomePage ? 'banner-text-container-top-padding' : ''}`}>
                        <h1 className="banner-title">{getHeaderText()}</h1>
                        <p className="banner-subtitle">
                            {getSubtitleText()}
                        </p>
                        <div className="banner-buttons mt-4">
                        {!isMenuPage && <Link to={'/menu'} className="btn btn-primary fs-5 me-3">Zobacz Menu</Link>}
                        <Link to={'/'} state={{scrollToDish: true}} className="btn btn-outline-light fs-5 me-3 mt-0">Obiad dnia</Link>
                        {/* <button onClick={onScrollToDishSection} className="btn btn-outline-light me-3 mt-0">Obiad dnia</button> */}
                        </div>
                    </div>
                </div>
                {isHomePage && (
                    <div className="scroll-down-icon-container d-flex justify-content-center align-items-center scroll-down-icon-show flex-column">
                        <div onClick={handleScrollDown} style={{cursor: 'pointer'}} className="scroll-button-container container">
                            <p className="fs-5 fw-lighter scroll-down-text">Przewiń w dół</p>
                            <img src={ScrollDown} alt="Przewiń stronę w dół" className="scroll-down-icon"/>
                        </div>
                    </div>
                )}
            </header>
        )

    } else {
        return null;
    }

}

export default Header;